import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import AddLinkIcon from "@mui/icons-material/AddLink";
import PersonIcon from "@mui/icons-material/Person";
import AppBarStyled from "./AppBarStyled";
import {
  IconButton,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Tooltip,
  Box,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../../../utils/supabaseClient";
import { useGetSideBarMenu } from "../../../../contexts/DrawerContext";
import LinkHouseModal from "./LinkHouseModal";

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const { menuMaster, handlerDrawerOpen } = useGetSideBarMenu();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const [linkModalOpen, setLinkModalOpen] = useState(false);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    await supabase.auth.signOut();
    handleMenuClose();
    navigate("/login", { replace: true });
  };

  const mainHeader = (
    <Toolbar sx={{ justifyContent: "space-between" }}>
      <IconButton
        aria-label="open drawer"
        onClick={() => handlerDrawerOpen(!drawerOpen)}
        edge="start"
        color="secondary"
        variant="light"
        sx={(theme) => ({
          color: "text.primary",
          bgcolor: drawerOpen ? "transparent" : "grey.100",
          ...theme.applyStyles("dark", {
            bgcolor: drawerOpen ? "transparent" : "background.default",
          }),
          ml: { xs: 0, lg: -2 },
        })}
      >
        {!drawerOpen ? <MenuIcon /> : <MenuOpenIcon />}
      </IconButton>
      <Box sx={{ flex: 1 }} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddLinkIcon />}
          sx={{
            fontWeight: 500,
            fontSize: "14px",
            textTransform: "none",
            borderRadius: 2,
            minWidth: downLG ? 0 : undefined,
            pl: downLG ? 1 : 2,
            pr: downLG ? 0 : 2,
          }}
          onClick={() => setLinkModalOpen(true)}
        >
          {downLG ? null : "Link a new house"}
        </Button>
        <LinkHouseModal
          open={linkModalOpen}
          onClose={() => setLinkModalOpen(false)}
        />
        <Tooltip title="Account">
          <IconButton onClick={handleAvatarClick} sx={{ padding: "0px" }}>
            <Avatar
              alt="User"
              sx={{ bgcolor: "grey.400", color: "white", padding: "0px" }}
            >
              <PersonIcon />
            </Avatar>
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Box>
    </Toolbar>
  );

  const appBar = {
    position: "fixed",
    color: "inherit",
    elevation: 0,
    sx: {
      borderBottom: "1px solid",
      borderBottomColor: "divider",
      zIndex: 1200,
      width: {
        xs: "100%",
        lg: drawerOpen ? `calc(100% - 260px)` : `calc(100% - 60px)`,
      },
    },
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
